import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import draggable from "vuedraggable";
import InlinePrompt from "@Shared/components/general/inline-prompt";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ESignOrderFilesPage",
  components: {
    draggable,
    InlinePrompt
  },
  props: {
    /**
     * Normalized documents
     */
    documents: {
      type: Object,
      default: () => ({})
    },
    selectedDocuments: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      fileNameMaxLength: 35
    };
  },
  computed: {
    selectedDocumentsValues: {
      get() {
        var _context;
        return _mapInstanceProperty(_context = this.selectedDocuments).call(_context, dId => this.documents[dId]);
      },
      set(value) {
        this.$emit("change", _mapInstanceProperty(value).call(value, ({
          documentId
        }) => documentId));
      }
    },
    isValid() {
      return true;
    }
  },
  watch: {
    isValid: {
      handler(value) {
        this.$emit("valid", value);
      },
      immediate: true
    }
  },
  methods: {
    handleDelete(documentId) {
      var _context2;
      const selectedDocuments = _filterInstanceProperty(_context2 = this.selectedDocuments).call(_context2, dId => dId !== documentId);
      this.$emit("change", selectedDocuments);
    }
  }
});